import { DigitalSignatureService } from './digital-signature.service';
import { DprApproversService } from './dpr-approvers.service';
import { DprCardService } from './dpr-card.service';
import { DprExportDataService } from './dpr-export-data.service';
import { DprService } from './dpr.service';
import {
  DprLocalPersistenceService,
  DprRemotePersistenceService,
} from './persistence';
import { DprOfflineService } from './sync';

export {
  DprService,
  DprCardService,
  DprApproversService,
  DigitalSignatureService,
  DprExportDataService,
};

export const services = [
  DprService,
  DprCardService,
  DprLocalPersistenceService,
  DprRemotePersistenceService,
  DprApproversService,
  DigitalSignatureService,
  DprOfflineService,
  DprExportDataService,
];
